import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import { TotemService } from '../totem.service';
import { Tienda } from '../tiendas/tienda';
import { TipoAccesos } from '../tiendas/accesos';
import { StorageService } from '../storage.service';
import { EventEmitterService } from '../event-emitter.service';
import { PRICE_TAG_ORANGE } from '../assets-inline';
import { AnalyticsService } from '../services/analytics.service';

@Component({
  selector: 'app-buscador',
  templateUrl: './buscador.component.html',
  styleUrls: ['./buscador.component.css']
})
export class BuscadorComponent implements OnInit, OnDestroy {
  // Icono price-tag inlineado (base64) para evitar ERR_CONNECTION_REFUSED
  // si el dev server reciclo durante el render. Embebido en el bundle JS.
  public priceTagOrange = PRICE_TAG_ORANGE;

  tiendas = [null];
  tiendasSinfiltro = [];
  subcategorias = [null];
  tiendasCargadas = false;
  servicios = [];
  serviciosSinFiltros = [];
  serviciosCargados = false;
  eventos = [];
  eventosSinFiltros = [];
  eventosCargados = false;

  textoBusqueda: string;

  seleccionBuscador = 'tiendas';

  tipoRuta = 'tiendas';
  estadoTitulo = true;
  subscription;
  datosRuta;
  public actual: string = '';

  // Debounce para evitar disparar un evento de busqueda en GA4 por cada tecla.
  private searchDebounce: any = null;

  constructor(private totemService: TotemService, private route: ActivatedRoute, private eventEmitterService: EventEmitterService,
              private router: Router, private storageService: StorageService,
              private analytics: AnalyticsService) {
                this.subscription = router.events.subscribe((val) => {
                  if (val instanceof NavigationEnd)
                    this.iniciarBuscador();
                });
                this.subscription = this.totemService.getLanguage().subscribe(language => {
                  this.actual = language;
                  this.obtenerTiendas();
                  this.obtenerServicios();
                  this.obtenetEventos();
                  
                });
              }

  async ngOnInit() {
    console.log("Inicio Buscador");
    this.actual = this.totemService.getLanguageact();
    console.log('actual',this.actual);
    this.datosRuta = await this.storageService.getNodosRuta();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  ManageFooter(manage: any) {
    this.eventEmitterService.activarFooter(manage);
    this.estadoTitulo = !this.estadoTitulo;
  }

  iniciarBuscador() {
    this.tipoRuta = this.route.snapshot.paramMap.get('tipo') ?
                    this.route.snapshot.paramMap.get('tipo') : 'tiendas';
    this.seleccionarBuscador(this.tipoRuta);
    this.obtenerTiendas();
    this.obtenetEventos();
  }

  seleccionarBuscador(tipo: string) {
    this.seleccionBuscador = tipo;
    this.textoBusqueda = '';
    console.log('[CAMBIO SELECCION]', this.seleccionBuscador);
    switch (this.seleccionBuscador) {
      case 'tiendas':
        this.tiendas = this.tiendasSinfiltro;
        break;
      case 'servicios':
        if (!this.serviciosCargados) {
          this.obtenerServicios();
        } else {
          console.log('[SERVICIOS]', this.servicios);
        }
        break;
      case 'eventos':
        if (!this.eventosCargados) {
          this.obtenetEventos();
        } else {
          console.log('[EVENTOS]', this.eventos);
        }
        break;
    }
  }

  async obtenerTiendas() {
    try {
      if(this.tiendas && this.subcategorias){
        // obtener tiendas
        const resultado = await this.totemService.obtenerTiendasOrdenadas(this.actual);
        // obtener categorias
        this.subcategorias = await this.totemService.obtenerCategoriasPorTiendas(this.actual,resultado);
        this.tiendas = this.totemService.sortByKey(resultado);
        this.tiendasSinfiltro = this.tiendas.slice();
        this.tiendasCargadas = true;
        console.log('[TIENDAS]', this.tiendas);
        console.log('[CATEGORIAS]', this.subcategorias);
      }
    } catch (err) {
      console.error(err);
    }
  }

  async obtenerServicios() {

    try {
      let resultado = await this.totemService.getTipoAccesos().toPromise();
      resultado = resultado.map( tipoAcceso => new TipoAccesos(tipoAcceso));
      this.servicios = resultado.filter( servicio => {
        if (servicio.Visible === 1 ) {
          return servicio;
        }
      });
      this.serviciosSinFiltros = this.servicios.slice();
      this.serviciosCargados = true;
      console.log('[SERVICIOS]', this.servicios);
    } catch (err) {
      console.error(err);
    }
  }
  async obtenetEventos() {
    this.actual = this.totemService.getLanguageact();
    console.log(this.actual);
    const eventoslist = await this.totemService.geteventos(this.actual).subscribe(eventos => {
      this.eventos = eventos.filter(evento => evento.tipo_evento === 'Evento' || evento.tipo_evento === 'Panorama' && !!evento.publicado);
      this.eventosSinFiltros = this.eventos.slice();
      this.eventosCargados = true;
      console.log(this.eventos);
    });
  }
    busqueda(event: any) {
      this.textoBusqueda = (event.target as HTMLInputElement).value;
      console.log('[BUSQUEDA]', this.textoBusqueda);
      switch (this.seleccionBuscador) {
        case 'tiendas':
          this.tiendas = !this.textoBusqueda || this.textoBusqueda === '' ?
                         this.tiendasSinfiltro : this.tiendas;
          this.filtrarTiendas(this.textoBusqueda);
          break;
        case 'servicios':
          this.filtrarServicios(this.textoBusqueda);
          break;
        case 'eventos':
          this.filtrarEventos(this.textoBusqueda);
          break;
      }

      // === GA4: trackear busqueda con debounce de 700ms ===
      // Solo mandamos el evento si el usuario dejo de escribir un rato, para
      // no generar un evento por cada tecla y no inflar la cuota de GA4.
      if (this.searchDebounce) { clearTimeout(this.searchDebounce); }
      const term = (this.textoBusqueda || '').trim();
      if (term.length >= 2) {
        this.searchDebounce = setTimeout(() => {
          let resultsCount = 0;
          switch (this.seleccionBuscador) {
            case 'tiendas':    resultsCount = (this.tiendas || []).length; break;
            case 'servicios':  resultsCount = (this.servicios || []).length; break;
            case 'eventos':    resultsCount = (this.eventos || []).length; break;
          }
          this.analytics.trackSearch({
            search_term: term,
            search_category: this.seleccionBuscador,
            results_count: resultsCount,
            zero_results: resultsCount === 0
          });
        }, 700);
      }
    }

    filtrarTiendas(input: any) {
      input = input.toUpperCase();
      // filtrar que comienzan con la busqueda
      const comienzan = this.tiendasSinfiltro.filter( tienda => {
        const nombreTienda = this.totemService.eliminarDiacriticos(tienda.nombre);
        return nombreTienda.toUpperCase().indexOf(input) === 0;
      });
      const tiendasFiltradas = this.eliminarFiltrados(this.tiendasSinfiltro, comienzan);
      // filtrar que contienen con la busqueda
      const contienen = tiendasFiltradas.filter(tienda => {
        const nombreTienda = this.totemService.eliminarDiacriticos(tienda.nombre);
        return nombreTienda.toUpperCase().includes(input);
      });
      const tiendasFiltradas2 = this.eliminarFiltrados(tiendasFiltradas, comienzan);
      // filtrar tiendas con tags
      let conTags = [];
      if (input.length > 1) {
        conTags = tiendasFiltradas2.filter((tienda: Tienda) => {
          const tiendasConTags = tienda.tags.filter((tagstiendas) => {
            const tag = this.totemService.eliminarDiacriticos(tagstiendas);
            return tag.toUpperCase().includes(input);
          });
          if (tiendasConTags.length !== 0) {
            const sindiDactricos = [];
            for (const tagsin of tiendasConTags) {
              sindiDactricos.push(this.totemService.eliminarDiacriticos(tagsin));
            }
            tienda.tags = sindiDactricos;
            return tienda;
          }
        });
      }
      const arregloTiendas = comienzan.concat(contienen).concat(conTags);
      this.tiendas = arregloTiendas;
      console.log('TIENDAS FILTRADAS', this.tiendas);
    }

    filtrarServicios(input: any) {
      input = input.toUpperCase();
      // filtrar que comienzan con la busqueda
      const comienzan = this.serviciosSinFiltros.filter( servicio => {
        const nombreServicio = servicio.nombre;
        return nombreServicio.toUpperCase().indexOf(input) === 0;
      });
      const serviciosFiltrados = this.eliminarFiltrados(this.serviciosSinFiltros, comienzan);
      // filtrar que contienen con la busqueda
      const contienen = serviciosFiltrados.filter(servicio => {
        const nombreServicio = servicio.nombre;
        return nombreServicio.toUpperCase().includes(input);
      });
      this.servicios = comienzan.concat(contienen);
    }

    filtrarEventos(input: any) {
      input = input.toUpperCase();
      // filtrar que comienzan con la busqueda
      const comienzan = this.eventosSinFiltros.filter( evento => {
        const nombreEvento = evento.nombre;
        return nombreEvento.toUpperCase().indexOf(input) === 0;
      });
      const eventosFiltrados = this.eliminarFiltrados(this.eventosSinFiltros, comienzan);
      // filtrar que contienen con la busqueda
      const contienen = eventosFiltrados.filter(evento => {
        const nombreEvento = evento.nombre;
        return nombreEvento.toUpperCase().includes(input);
      });
      this.eventos = comienzan.concat(contienen);
    }

    eliminarFiltrados(tiendasporfiltrar: any, tiendasfiltradas: any) {
      const nuevalista = tiendasporfiltrar.filter( tienda => {
        return tiendasfiltradas.indexOf(tienda) === -1;
      });
      return nuevalista;
    }

    async iniciarRutaServicio(sid: any) {
      await this.storageService.setDestino(sid, 'servicios');
      this.router.navigate([`donde-quiero-ir`]);
    }
    getTranslation(key: string) {
      const word = this.totemService.getTranslation(key);
      if (word){
        return word[0].texto_descripcion;
      }
    }
}
